import Status from '@/models/api/resource/status'
import * as CurrentTime from '@/models/current-time/functions'
import _ from 'lodash'
import { ApiTag } from './tags'

export default abstract class Resource<
  // TODO: Resourceとして共通のデータ構造を定義可能 & すべきなら、そのサブタイプのみ指定可能にする
  // TODO: Resourceとして共通のデータ構造を定義不可能 or すべきでないなら、各サブタイプで最適な型定義の指定を必須にする
  Data extends object = any
> {
  protected _data: Data

  public constructor(apiData: Data) {
    this._data = apiData
  }

  get(path: string, defaultValue?: any) {
    return _.get(this._data, path, defaultValue)
  }

  get id(): string {
    return _.get(this._data, 'id')
  }

  get shortId(): string {
    return this.get('shortid')
  }

  get name() {
    return this.get('name')
  }

  get title() {
    return this.get('title')
  }

  get tags(): ApiTag[] {
    return this.get('tags', []).map((t: any) => new ApiTag(t))
  }

  get images() {
    return this.get('images')
  }

  get publishAt(): Date {
    return new Date(this.get('publish_at'))
  }

  get publicAt(): Date {
    return new Date(this.get('public_at'))
  }

  get closeAt(): Date {
    return new Date(this.get('close_at'))
  }

  get updatedAt(): Date {
    return new Date(this.get('updated_at'))
  }

  get status(): Status {
    return new Status(this.get('status_id'))
  }

  get isWithinPublicPeriod(): boolean {
    return this.publicAt <= this.current.now && this.current.now <= this.closeAt
  }

  hasTag(pathname: string): boolean {
    return this.tags.some(tag => tag.pathname === pathname)
  }

  findTag(namespace: string[]): ApiTag | undefined {
    const _namespace = `${namespace.join('.')}\\.`
    const regExp = new RegExp(`^${_namespace}(.*)`)

    return _.find(this.tags, tag => regExp.test(tag.pathname))
  }

  getThumbnail(): string | null {
    const images = this.images

    if (_.isEmpty(images)) {
      return null
    }

    const target = _.find(images, ['display_level', 0])

    if (target) {
      return target.url_xs
    }

    // Fallback
    return images[0].url_xs
  }

  /**
   * Resourceオブジェクトの内部データを基に、別形式のデータ構造へ変換する
   */
  map<T>(f: (data: Data) => T): T {
    return f({ ...this._data })
  }

  protected get current() {
    return CurrentTime.create()
  }
}
